import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface HistoryState {
  history: string[];
}

const initialState: HistoryState = {
  history: ["Analytics"],
};

const routes = {
  Analytics: "/analytics",
  Library: "/library",
  Dashboard: "/dashboard",
  Profile: "/profile",
  Notifications: "/notifications",
};

const historySlice = createSlice({
  name: "history",
  initialState,
  reducers: {
    setHistory: (state, action: PayloadAction<string>) => {
      const name = Object.entries(routes).find((pair) =>
        action.payload.includes(pair[1])
      );
      if (state.history.length > 5) state.history.shift();
      state.history.push(name ? name[0] : "Back");
    },
    removeHistory: (state) => {
      state.history.pop();
    },
  },
});

export const { setHistory, removeHistory } = historySlice.actions;

export default historySlice.reducer;
